import {
  FETCH,
  DONE,
  FAIL,
  GET,
  EDIT,
  RESET,
  ONE,
  POST,
  DELETE,
  SCHEDULE,
  PSYCHOLOGIST,
  WORK,
  FILTER,
  GROUPS,
  STUDENT,
  TEACHERS,
} from "../../constants";

import reducerStatuses from "../../status";
import { createReducer, PayloadAction } from "@reduxjs/toolkit";
import { TFetch } from "../../types";

const initialState: TFetch = {

  psychologistSchedule: {
    ...reducerStatuses,
    data: [] as any,
  },
  psychologistScheduleOne: {
    ...reducerStatuses,
    data: [] as any,
  },
  postPsychologistSchedule: {
    ...reducerStatuses,
    data: [] as any,
  },
  editPsychologistSchedule: {
    ...reducerStatuses,
    data: [] as any,
  },
  deletePsychologistSchedule: {
    ...reducerStatuses,
    data: [] as any,
  },
  psychologistWork:{
    ...reducerStatuses,
    data: [] as any,
  },
  psychologistWorkOne:{
    ...reducerStatuses,
    data: [] as any,
  },
  postPsychologistWork:{
    ...reducerStatuses,
    data: [] as any,
  },
  editPsychologistWork:{
    ...reducerStatuses,
    data: [] as any,
  },
  deletePsychologistWork:{
    ...reducerStatuses,
    data: [] as any,
  },
  psychologistWorkFilter:{
    ...reducerStatuses,
    data: [] as any,
  },
  psychologistWorkGroups:{
    ...reducerStatuses,
    data: [] as any,
  },
  psychologistWorkGroupsStudents:{
    ...reducerStatuses,
    data: [] as any,
  },
  psychologistTeachers:{
    ...reducerStatuses,
    data: [] as any,
  }
};

export default createReducer(initialState, builder =>
  builder

    .addCase(GET + PSYCHOLOGIST + SCHEDULE + FETCH, (state) => ({
      ...state,
      psychologistSchedule: {
        ...initialState.psychologistSchedule,
        loading: true
      }
    }))
    .addCase(GET + PSYCHOLOGIST + SCHEDULE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistSchedule: {
        ...initialState.psychologistSchedule,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + PSYCHOLOGIST + SCHEDULE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistSchedule: {
        ...initialState.psychologistSchedule,
        failed: true
      }
    }))




    .addCase(GET + PSYCHOLOGIST + SCHEDULE + ONE + FETCH, (state) => ({
      ...state,
      psychologistScheduleOne: {
        ...initialState.psychologistScheduleOne,
        loading: true
      }
    }))
    .addCase(GET + PSYCHOLOGIST + SCHEDULE + ONE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistScheduleOne: {
        ...initialState.psychologistScheduleOne,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + PSYCHOLOGIST + SCHEDULE + ONE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistScheduleOne: {
        ...initialState.psychologistScheduleOne,
        failed: true
      }
    }))


    .addCase(POST + PSYCHOLOGIST + SCHEDULE, (state) => ({
      ...state,
      postPsychologistSchedule: {
        ...initialState.postPsychologistSchedule,
        loading: true
      }
    }))
    .addCase(POST + PSYCHOLOGIST + SCHEDULE + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      postPsychologistSchedule: {
        ...initialState.postPsychologistSchedule,
        success: true,
        data: payload
      }
    }))
    .addCase(POST + PSYCHOLOGIST + SCHEDULE + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      postPsychologistSchedule: {
        ...initialState.postPsychologistSchedule,
        failed: true
      }
    }))
    .addCase(POST + PSYCHOLOGIST + SCHEDULE + RESET, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      postPsychologistSchedule: {
        ...initialState.postPsychologistSchedule,
        data: []
      }
    }))

    .addCase(EDIT + PSYCHOLOGIST + SCHEDULE, (state) => ({
      ...state,
      editPsychologistSchedule: {
        ...initialState.editPsychologistSchedule,
        loading: true
      }
    }))
    .addCase(EDIT + PSYCHOLOGIST + SCHEDULE + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      editPsychologistSchedule: {
        ...initialState.editPsychologistSchedule,
        success: true,
        data: payload
      }
    }))
    .addCase(EDIT + PSYCHOLOGIST + SCHEDULE + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      editPsychologistSchedule: {
        ...initialState.editPsychologistSchedule,
        failed: true
      }
    }))
    .addCase(EDIT + PSYCHOLOGIST + SCHEDULE + RESET, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      editPsychologistSchedule: {
        ...initialState.editPsychologistSchedule,
        data: []
      }
    }))


    .addCase(DELETE + PSYCHOLOGIST + SCHEDULE, (state) => ({
      ...state,
      deletePsychologistSchedule: {
        ...initialState.deletePsychologistSchedule,
        loading: true
      }
    }))
    .addCase(DELETE + PSYCHOLOGIST + SCHEDULE + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deletePsychologistSchedule: {
        ...initialState.deletePsychologistSchedule,
        success: true,
        data: payload
      }
    }))
    .addCase(DELETE + PSYCHOLOGIST + SCHEDULE + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deletePsychologistSchedule: {
        ...initialState.deletePsychologistSchedule,
        failed: true
      }
    }))



    .addCase(PSYCHOLOGIST + WORK + FETCH, (state) => ({
      ...state,
      psychologistWork: {
        ...initialState.psychologistWork,
        loading: true
      }
    }))
    .addCase(PSYCHOLOGIST + WORK + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistWork: {
        ...initialState.psychologistWork,
        success: true,
        data: payload
      }
    }))
    .addCase(PSYCHOLOGIST + WORK + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistWork: {
        ...initialState.psychologistWork,
        failed: true
      }
    }))



    .addCase(PSYCHOLOGIST + WORK + ONE + FETCH, (state) => ({
      ...state,
      psychologistWorkOne: {
        ...initialState.psychologistWorkOne,
        loading: true
      }
    }))
    .addCase(PSYCHOLOGIST + WORK + ONE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistWorkOne: {
        ...initialState.psychologistWorkOne,
        success: true,
        data: payload
      }
    }))
    .addCase(PSYCHOLOGIST + WORK + ONE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistWorkOne: {
        ...initialState.psychologistWorkOne,
        failed: true
      }
    }))


    .addCase(POST + PSYCHOLOGIST + WORK, (state) => ({
      ...state,
      postPsychologistWork: {
        ...initialState.postPsychologistWork,
        loading: true
      }
    }))
    .addCase(POST + PSYCHOLOGIST + WORK + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      postPsychologistWork: {
        ...initialState.postPsychologistWork,
        success: true,
        data: payload
      }
    }))
    .addCase(POST + PSYCHOLOGIST + WORK + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      postPsychologistWork: {
        ...initialState.postPsychologistWork,
        failed: true
      }
    }))



    .addCase(EDIT + PSYCHOLOGIST + WORK, (state) => ({
      ...state,
      editPsychologistWork: {
        ...initialState.editPsychologistWork,
        loading: true
      }
    }))
    .addCase(EDIT + PSYCHOLOGIST + WORK + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      editPsychologistWork: {
        ...initialState.editPsychologistWork,
        success: true,
        data: payload
      }
    }))
    .addCase(EDIT + PSYCHOLOGIST + WORK + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      editPsychologistWork: {
        ...initialState.editPsychologistWork,
        failed: true
      }
    }))


    .addCase(DELETE + PSYCHOLOGIST + WORK, (state) => ({
      ...state,
      deletePsychologistWork: {
        ...initialState.deletePsychologistWork,
        loading: true
      }
    }))
    .addCase(DELETE + PSYCHOLOGIST + WORK + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deletePsychologistWork: {
        ...initialState.deletePsychologistWork,
        success: true,
        data: payload
      }
    }))
    .addCase(DELETE + PSYCHOLOGIST + WORK + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deletePsychologistWork: {
        ...initialState.deletePsychologistWork,
        failed: true
      }
    }))




    .addCase(PSYCHOLOGIST + WORK + FILTER + FETCH, (state) => ({
      ...state,
      psychologistWorkFilter: {
        ...initialState.psychologistWorkFilter,
        loading: true
      }
    }))
    .addCase(PSYCHOLOGIST + WORK + FILTER + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistWorkFilter: {
        ...initialState.psychologistWorkFilter,
        success: true,
        data: payload
      }
    }))
    .addCase(PSYCHOLOGIST + WORK + FILTER + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistWorkFilter: {
        ...initialState.psychologistWorkFilter,
        failed: true
      }
    }))


    .addCase(PSYCHOLOGIST + WORK + GROUPS + FETCH, (state) => ({
      ...state,
      psychologistWorkGroups: {
        ...initialState.psychologistWorkGroups,
        loading: true
      }
    }))
    .addCase(PSYCHOLOGIST + WORK + GROUPS + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistWorkGroups: {
        ...initialState.psychologistWorkGroups,
        success: true,
        data: payload
      }
    }))
    .addCase(PSYCHOLOGIST + WORK + GROUPS + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistWorkGroups: {
        ...initialState.psychologistWorkGroups,
        failed: true
      }
    }))



    .addCase(PSYCHOLOGIST + WORK + GROUPS + STUDENT + FETCH, (state) => ({
      ...state,
      psychologistWorkGroupsStudents: {
        ...initialState.psychologistWorkGroupsStudents,
        loading: true
      }
    }))
    .addCase(PSYCHOLOGIST + WORK + GROUPS + STUDENT + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistWorkGroupsStudents: {
        ...initialState.psychologistWorkGroupsStudents,
        success: true,
        data: payload
      }
    }))
    .addCase(PSYCHOLOGIST + WORK + GROUPS + STUDENT + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistWorkGroupsStudents: {
        ...initialState.psychologistWorkGroupsStudents,
        failed: true
      }
    }))


    .addCase(PSYCHOLOGIST + TEACHERS + FETCH, (state) => ({
      ...state,
      psychologistTeachers: {
        ...initialState.psychologistTeachers,
        loading: true
      }
    }))
    .addCase(PSYCHOLOGIST + TEACHERS + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistTeachers: {
        ...initialState.psychologistTeachers,
        success: true,
        data: payload
      }
    }))
    .addCase(PSYCHOLOGIST + TEACHERS + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychologistTeachers: {
        ...initialState.psychologistTeachers,
        failed: true
      }
    }))
)
